// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import NestedFieldsController from "./nested_fields_controller"
application.register("nested-fields", NestedFieldsController)

import PurchaseItemController from "./purchase_item_controller"
application.register("purchase-item", PurchaseItemController)

import RubyUi__CheckboxGroupController from "./ruby_ui/checkbox_group_controller"
application.register("ruby-ui--checkbox-group", RubyUi__CheckboxGroupController)

import RubyUi__ContextMenuController from "./ruby_ui/context_menu_controller"
application.register("ruby-ui--context-menu", RubyUi__ContextMenuController)

import RubyUi__DropdownMenuController from "./ruby_ui/dropdown_menu_controller"
application.register("ruby-ui--dropdown-menu", RubyUi__DropdownMenuController)

import RubyUi__FormFieldController from "./ruby_ui/form_field_controller"
application.register("ruby-ui--form-field", RubyUi__FormFieldController)

import RubyUi__HoverCardController from "./ruby_ui/hover_card_controller"
application.register("ruby-ui--hover-card", RubyUi__HoverCardController)

import RubyUi__SelectController from "./ruby_ui/select_controller"
application.register("ruby-ui--select", RubyUi__SelectController)

import RubyUi__SelectItemController from "./ruby_ui/select_item_controller"
application.register("ruby-ui--select-item", RubyUi__SelectItemController)

import RubyUi__TabsController from "./ruby_ui/tabs_controller"
application.register("ruby-ui--tabs", RubyUi__TabsController)

import RubyUi__ThemeToggleController from "./ruby_ui/theme_toggle_controller"
application.register("ruby-ui--theme-toggle", RubyUi__ThemeToggleController)

import SaleFormController from "./sale_form_controller"
application.register("sale-form", SaleFormController)

import SaleItemController from "./sale_item_controller"
application.register("sale-item", SaleItemController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)
